import {
  LayoutProps,
  RankedTester,
  rankWith,
  uiTypeIs,
  VerticalLayout,
} from "@jsonforms/core";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import React, { FunctionComponent } from "react";
import { renderChildren } from "./util";

export const verticalLayoutTester: RankedTester = rankWith(
  4,
  uiTypeIs("VerticalLayout"),
);

export const VerticalLayoutRenderer = (props: LayoutProps) => {
  const { data: _data, ...otherProps } = props;
  // We don't hand over data to the layout renderer to avoid rerendering it with every data change
  return <VerticalLayoutRendererComponent {...otherProps} />;
};

const VerticalLayoutRendererComponent: FunctionComponent<LayoutProps> =
  React.memo(function VerticalLayoutRendererComponent({
    schema,
    uischema,
    path,
    enabled,
    visible,
  }: LayoutProps) {
    const verticalLayout = uischema as VerticalLayout;

    return (
      <div
        hidden={visible === undefined || visible === null ? false : !visible}
      >
        {renderChildren(verticalLayout, schema, "mb-4", path, enabled)}
      </div>
    );
  });

export default withJsonFormsLayoutProps(VerticalLayoutRenderer);
